module.exports = __webpack_public_path__ + "static/media/lu.c401f0dc.svg";